"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    MuiSlider: {
        root: {
            color: theme.palette.primary.light,
            height: 8,
            padding: '10px 0',
        },
        thumb: {
            height: 24,
            width: 24,
            backgroundColor: '#fff',
            border: '2px solid currentColor',
            marginTop: -8,
            marginLeft: -12,
            '&:focus, &:hover, &$active': {
                boxShadow: 'inherit',
            },
        },
        active: {},
        valueLabel: {
        // left: 'calc(-50% + 4px)',
        },
        track: {
            height: 8,
            borderRadius: 4,
        },
        rail: {
            height: 8,
            borderRadius: 4,
            backgroundColor: '#EAF5F1', // theme.palette.background.default,
        },
        mark: {
            display: 'none',
        },
        'markLabel:first': {
            color: theme.palette.text.secondary,
            fontSize: '0.8em',
            transform: 'none',
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2xpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL292ZXJyaWRlcy9zbGlkZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxrQkFBZSxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDdkIsU0FBUyxFQUFFO1FBQ1QsSUFBSSxFQUFFO1lBQ0osS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLEtBQUs7WUFDbEMsTUFBTSxFQUFFLENBQUM7WUFDVCxPQUFPLEVBQUUsUUFBUTtTQUNsQjtRQUNELEtBQUssRUFBRTtZQUNMLE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFLEVBQUU7WUFDVCxlQUFlLEVBQUUsTUFBTTtZQUN2QixNQUFNLEVBQUUsd0JBQXdCO1lBQ2hDLFNBQVMsRUFBRSxDQUFDLENBQUM7WUFDYixVQUFVLEVBQUUsQ0FBQyxFQUFFO1lBQ2YsNEJBQTRCLEVBQUU7Z0JBQzVCLFNBQVMsRUFBRSxTQUFTO2FBQ3JCO1NBQ0Y7UUFDRCxNQUFNLEVBQUUsRUFBRTtRQUNWLFVBQVUsRUFBRTtRQUNWLDRCQUE0QjtTQUM3QjtRQUNELEtBQUssRUFBRTtZQUNMLE1BQU0sRUFBRSxDQUFDO1lBQ1QsWUFBWSxFQUFFLENBQUM7U0FDaEI7UUFDRCxJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsQ0FBQztZQUNULFlBQVksRUFBRSxDQUFDO1lBQ2YsZUFBZSxFQUFFLFNBQVMsRUFBRSxvQ0FBb0M7U0FDakU7UUFDRCxJQUFJLEVBQUU7WUFDSixPQUFPLEVBQUUsTUFBTTtTQUNoQjtRQUNELGlCQUFpQixFQUFFO1lBQ2pCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxTQUFTO1lBQ25DLFFBQVEsRUFBRSxPQUFPO1lBQ2pCLFNBQVMsRUFBRSxNQUFNO1NBQ2xCO0tBQ0Y7Q0FDRixDQUFDLENBQUMifQ==